<div class="row content" *appRole="['Configuracion.Ver']">
  <div class="col-sm-2">
    <app-nav-panel-configuracion></app-nav-panel-configuracion>
  </div>
  <div class="col-sm-10">
    <mat-accordion class="example-headers-align">

      <!-- Parametros Generales -->
      <mat-expansion-panel [expanded]='true'>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary">settings</mat-icon>
            Parámetros Generales
          </mat-panel-title>
          <mat-panel-description>
            Configuración básica del sistema
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <form [formGroup]="formParametrosGenerales">
            <div class="parametros-grid">

              <!-- Card: Código Alquiler -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Código Alquiler</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.CodigoAlquiler || 'Código utilizado para identificar alquileres en el
                    sistema'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Código</mat-label>
                    <input matInput type="text" formControlName="CodigoAlquiler">
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Duración Archivos Temporales -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Duración Archivos Temporales</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.DuracionMesesArchivosTemporales || 'Tiempo en meses antes de eliminar
                    archivos temporales del sistema'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Meses</mat-label>
                    <input matInput type="number" min="1" formControlName="DuracionMesesArchivosTemporales">
                    <span matSuffix>meses</span>
                    <mat-error *ngIf="paramGeneral.DuracionMesesArchivosTemporales.errors?.required">
                      Campo requerido
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Herramienta Generación PDF -->
              <mat-card class="parametro-card" *appRole="['Configuracion.VerSAdministrador']">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Herramienta Generación PDF</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.HerramientaGeneracionPDF || 'Seleccione la librería para generar
                    documentos PDF'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Herramienta</mat-label>
                    <mat-select formControlName="HerramientaGeneracionPDF">
                      <mat-option [value]="1">
                        <div class="option-content">
                          <strong>Spire PDF</strong>
                        </div>
                      </mat-option>
                      <mat-option [value]="2">
                        <div class="option-content">
                          <strong>Wkhtmltopdf</strong>
                        </div>
                      </mat-option>
                      <mat-option [value]="3">
                        <div class="option-content">
                          <strong>PuppeteerSharp</strong>
                        </div>
                      </mat-option>
                      <mat-option [value]="4">
                        <div class="option-content">
                          <strong>Playwright</strong>
                        </div>
                      </mat-option>
                      <mat-option [value]="5">
                        <div class="option-content">
                          <strong>SelectPdf</strong>
                        </div>
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="paramGeneral.HerramientaGeneracionPDF?.errors?.required">
                      Campo requerido
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <mat-card class="parametro-card" *appRole="['Configuracion.VerSAdministrador']">
                 <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Ruta Playwright Browsers</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.PlaywrightBrowsersPath || 'Ruta donde Playwright busca los browsers instalados (ej: C:\ms-playwright)'}}

                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Ruta</mat-label>
                    <input matInput type="text" formControlName="PlaywrightBrowsersPath">
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

            </div>

            <div class="actions-container">
              <button mat-raised-button color="primary" (click)="onSubmitParametrosGenerales()"
                [disabled]="!formParametrosGenerales.valid" *appRole="['Configuracion.Ver']">
                <mat-icon>save</mat-icon>
                Guardar Cambios
              </button>
            </div>
          </form>
        </ng-template>
      </mat-expansion-panel>

      <!-- Parametros Contables -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary">account_balance</mat-icon>
            Parámetros Contables
          </mat-panel-title>
          <mat-panel-description>
            Configuración contable y financiera
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <form [formGroup]="formParametrosContables">
            <div class="parametros-grid">

              <!-- Card: IVA -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>IVA</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.Iva || 'Porcentaje de IVA aplicado en operaciones'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Porcentaje IVA</mat-label>
                    <input matInput type="number" min="0" max="100" step="0.01" formControlName="Iva">
                    <span matPrefix>%&nbsp;</span>
                    <mat-error *ngIf="paramContable.Iva.errors?.required">
                      Campo requerido
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Caja -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Caja</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.Caja || 'Código de cuenta de caja predeterminada'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Código de Caja</mat-label>
                    <input matInput type="text" formControlName="Caja">
                    <mat-error *ngIf="paramContable.Caja.errors?.required">
                      Campo requerido
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Cuenta Contable Defecto -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Cuenta Contable Defecto</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.CuentaContableDefecto || 'Cuenta contable utilizada por defecto en
                    operaciones'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Cuenta Contable</mat-label>
                    <mat-select formControlName="CuentaContableDefecto">
                      <mat-option *ngFor="let cuenta of lstCuentasContable; trackBy: trackByItems" [value]="cuenta.id">
                        {{cuenta.descripcion}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="paramContable.CuentaContableDefecto.errors?.required">
                      Campo requerido
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

            </div>

            <div class="actions-container">
              <button mat-raised-button color="primary" (click)="onSubmitParametrosContables()"
                [disabled]="!formParametrosContables.valid" *appRole="['Configuracion.Ver']">
                <mat-icon>save</mat-icon>
                Guardar Cambios
              </button>
            </div>
          </form>
        </ng-template>
      </mat-expansion-panel>

      <!-- Comisiones -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary">payments</mat-icon>
            Comisiones
          </mat-panel-title>
          <mat-panel-description>
            Porcentajes de comisión aplicados
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <form [formGroup]="formParametrosComisiones">
            <div class="parametros-grid">

              <!-- Card: Comisión Ganancia Propietario -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Comisión Ganancia Propietario</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.ComisionGananciaPropietario || 'Porcentaje de comisión aplicado a las
                    ganancias del propietario'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Porcentaje</mat-label>
                    <input matInput type="number" min="0" max="100" step="0.01"
                      formControlName="ComisionGananciaPropietario">
                    <span matPrefix>%&nbsp;</span>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Comisión Ganancia Inmobiliaria -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Comisión Ganancia Inmobiliaria</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.ComisionGananciaInmobiliaria || 'Porcentaje de comisión de la
                    inmobiliaria'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Porcentaje</mat-label>
                    <input matInput type="number" min="0" max="100" step="0.01"
                      formControlName="ComisionGananciaInmobiliaria">
                    <span matPrefix>%&nbsp;</span>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

            </div>

            <div class="actions-container">
              <button mat-raised-button color="primary" (click)="onSubmitParametrosComisiones()"
                [disabled]="!formParametrosComisiones.valid" *appRole="['Configuracion.Ver']">
                <mat-icon>save</mat-icon>
                Guardar Cambios
              </button>
            </div>
          </form>
        </ng-template>
      </mat-expansion-panel>

      <!-- Parametros Notificaciones -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary">notifications</mat-icon>
            Notificaciones
          </mat-panel-title>
          <mat-panel-description>
            Configuración de alertas y recordatorios
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <form [formGroup]="formNotificaciones">
            <div class="parametros-grid">

              <!-- Card: Día Generación Resumen -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Día Generación Resumen</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.FechaGenResumen || 'Día del mes en que se genera el resumen
                    automático'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Día del mes</mat-label>
                    <input matInput type="number" min="1" max="31" formControlName="FechaGenResumen">
                    <mat-error *ngIf="paramNotificaciones.FechaGenResumen.errors?.required">
                      Campo requerido
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Día Generación Liquidación -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Día Generación Liquidación</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.FechaGenLiquizacion || 'Día del mes en que se genera la liquidación
                    automática'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Día del mes</mat-label>
                    <input matInput type="number" min="1" max="31" formControlName="FechaGenLiquizacion">
                    <mat-error *ngIf="paramNotificaciones.FechaGenLiquizacion.errors?.required">
                      Campo requerido
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Días Finaliza Contrato -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Alerta Vencimiento Contrato</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.DiasFinalizaContrato || 'Días de anticipación para notificar
                    vencimiento de contratos'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Días de anticipación</mat-label>
                    <input matInput type="number" min="1" formControlName="DiasFinalizaContrato">
                    <span matSuffix>días</span>
                    <mat-error *ngIf="paramNotificaciones.DiasFinalizaContrato.errors?.required">
                      Campo requerido
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Meses Deuda Propiedad -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Alerta Deuda Propiedad</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.CantidadMesesDeudaPropiedad || 'Cantidad de meses de deuda para
                    generar alerta'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Meses de deuda</mat-label>
                    <input matInput type="number" min="1" formControlName="CantidadMesesDeudaPropiedad">
                    <span matSuffix>meses</span>
                    <mat-error *ngIf="paramNotificaciones.CantidadMesesDeudaPropiedad.errors?.required">
                      Campo requerido
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Duración Alertas -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Duración de Alertas</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.DuracionAlertas || 'Tiempo en días que permanecen visibles las
                    alertas'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Duración</mat-label>
                    <input matInput type="number" min="1" formControlName="DuracionAlertas">
                    <span matSuffix>días</span>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Aviso por mail al emitir recibo -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Aviso por mail al emitir recibo</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.EmailNotificacionRecibo || 'Correos que reciben una copia oculta
                    cuando se emite un recibo. Sólo se avisa de las propiedades marcadas con "Avisar por mail al emitir
                    recibo". Varios correos separados por punto y coma.'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Correos de notificación</mat-label>
                    <input matInput type="text" formControlName="EmailNotificacionRecibo"
                      placeholder="administracion@inmobiliaria.com; contaduria@inmobiliaria.com">
                    <mat-icon matSuffix>mark_email_read</mat-icon>
                    <mat-hint>Separá varios correos con punto y coma (;). Vacío = no se notifica a nadie.</mat-hint>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

            </div>

            <div class="actions-container">
              <button mat-raised-button color="primary" (click)="onSubmitParametrosNotificaciones()"
                [disabled]="!formNotificaciones.valid" *appRole="['Configuracion.Ver']">
                <mat-icon>save</mat-icon>
                Guardar Cambios
              </button>
            </div>
          </form>
        </ng-template>
      </mat-expansion-panel>

      <!-- Ajuste de Contratos -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary">trending_up</mat-icon>
            Ajuste de Contratos
          </mat-panel-title>
          <mat-panel-description>
            Actualización automática de alquileres por índice
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <form [formGroup]="formAjustesContratos">
            <div class="parametros-grid">

              <!-- Card: Proceso automático -->
              <mat-card class="parametro-card">
                <mat-card-header>
                  <mat-card-title>Proceso automático</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.ProcesoAutomaticoAjusteHabilitado || 'Ajusta los alquileres de todos los
                    contratos una vez por mes, en el día y la hora configurados.'}}
                  </p>
                  <mat-slide-toggle formControlName="ProcesoAutomaticoAjusteHabilitado" color="primary">
                    Ejecutar automáticamente
                  </mat-slide-toggle>
                  <p class="parametro-descripcion">
                    Última ejecución: {{ ultimaEjecucionAjuste ? (ultimaEjecucionAjuste | date:'dd/MM/yyyy HH:mm') : 'Nunca' }}
                  </p>
                </mat-card-content>
              </mat-card>

              <!-- Card: Día de ejecución -->
              <mat-card class="parametro-card">
                <mat-card-header>
                  <mat-card-title>Día de ejecución</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.ProcesoAutomaticoAjusteDia || 'Día del mes en que corre el ajuste
                    automático.'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Día del mes</mat-label>
                    <input matInput type="number" min="1" max="28" formControlName="ProcesoAutomaticoAjusteDia">
                    <mat-hint>Del 1 al 28, para que exista en todos los meses.</mat-hint>
                    <mat-error *ngIf="paramAjustes.ProcesoAutomaticoAjusteDia.errors?.required">Campo requerido</mat-error>
                    <mat-error *ngIf="paramAjustes.ProcesoAutomaticoAjusteDia.errors?.min || paramAjustes.ProcesoAutomaticoAjusteDia.errors?.max">
                      Tiene que ser un día entre 1 y 28
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Hora de ejecución -->
              <mat-card class="parametro-card">
                <mat-card-header>
                  <mat-card-title>Hora de ejecución</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.ProcesoAutomaticoAjusteHora || 'Hora a partir de la cual corre el
                    ajuste el día configurado.'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Hora</mat-label>
                    <input matInput type="time" formControlName="ProcesoAutomaticoAjusteHora">
                    <mat-hint>Si el servidor estuvo apagado a esa hora, corre apenas vuelve (una vez por mes).</mat-hint>
                    <mat-error *ngIf="paramAjustes.ProcesoAutomaticoAjusteHora.errors?.required">Campo requerido</mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Honorarios en ajustes -->
              <mat-card class="parametro-card">
                <mat-card-header>
                  <mat-card-title>Honorarios por ajuste</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.HabilitaComisionCalculoAjuste || 'Genera el movimiento de honorarios por
                    el aumento del alquiler, en las cuotas del plan de pago del contrato.'}}
                  </p>
                  <mat-slide-toggle formControlName="HabilitaComisionCalculoAjuste" color="primary">
                    Generar honorarios
                  </mat-slide-toggle>
                </mat-card-content>
              </mat-card>

              <!-- Card: Sellado en ajustes -->
              <mat-card class="parametro-card">
                <mat-card-header>
                  <mat-card-title>Sellado por ajuste</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.HabilitaSelladoCalculoAjuste || 'Genera el movimiento de sellado por
                    el aumento del alquiler.'}}
                  </p>
                  <mat-slide-toggle formControlName="HabilitaSelladoCalculoAjuste" color="primary">
                    Generar sellado
                  </mat-slide-toggle>
                </mat-card-content>
              </mat-card>

            </div>

            <div class="actions-container">
              <button mat-raised-button color="primary" (click)="onSubmitParametrosAjustesContratos()"
                [disabled]="!formAjustesContratos.valid" *appRole="['Configuracion.Ver']">
                <mat-icon>save</mat-icon>
                Guardar Cambios
              </button>
            </div>
          </form>
        </ng-template>
      </mat-expansion-panel>

      <!-- Parametros Correo -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary">email</mat-icon>
            Correo Electrónico
          </mat-panel-title>
          <mat-panel-description>
            Configuración SMTP para envío de correos
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <form [formGroup]="formParametrosCorreo">
            <div class="parametros-grid">

              <!-- Card: Servidor SMTP -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Servidor SMTP</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.SmtpServer || 'Dirección del servidor SMTP para envío de correos'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Servidor</mat-label>
                    <input matInput type="text" formControlName="SmtpServer" placeholder="smtp.ejemplo.com">
                    <mat-error *ngIf="paramCorreo.SmtpServer.errors?.required">
                      Campo requerido
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Puerto -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Puerto SMTP</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.Port || 'Puerto del servidor SMTP (generalmente 587 o 465)'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Puerto</mat-label>
                    <input matInput type="number" formControlName="Port" placeholder="587">
                    <mat-error *ngIf="paramCorreo.Port.errors?.required">
                      Campo requerido
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Cuenta -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Cuenta de Correo</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.Sender || 'Dirección de correo remitente'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" formControlName="Sender" placeholder="correo@ejemplo.com">
                    <mat-error *ngIf="paramCorreo.Sender.errors?.required">
                      Campo requerido
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Usuario -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Usuario SMTP</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.Username || 'Usuario para autenticación SMTP'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Usuario</mat-label>
                    <input matInput type="text" formControlName="Username">
                    <mat-error *ngIf="paramCorreo.Username.errors?.required">
                      Campo requerido
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: Contraseña -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Contraseña SMTP</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.Password || 'Contraseña para autenticación SMTP'}}
                  </p>
                  <mat-form-field class="full-width">
                    <mat-label>Contraseña</mat-label>
                    <input matInput type="password" formControlName="Password">
                    <mat-error *ngIf="paramCorreo.Password.errors?.required">
                      Campo requerido
                    </mat-error>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>

              <!-- Card: SSL/TLS -->
              <mat-card class="parametro-card">
                <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
                  [fullScreen]="false">
                </ngx-spinner>
                <mat-card-header>
                  <mat-card-title>Seguridad SSL/TLS</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.SslTls || 'Habilitar conexión segura SSL/TLS'}}
                  </p>
                  <mat-slide-toggle formControlName="SslTls" color="primary">
                    Usar SSL/TLS
                  </mat-slide-toggle>
                </mat-card-content>
              </mat-card>

            </div>

            <div class="actions-container">
              <button mat-raised-button color="primary" (click)="onSubmitParametrosCorreo()"
                [disabled]="!formParametrosCorreo.valid" *appRole="['Configuracion.Ver']">
                <mat-icon>save</mat-icon>
                Guardar Cambios
              </button>
              <button mat-stroked-button color="accent" type="button" (click)="abrirTestEmail()">
                <mat-icon>send</mat-icon>
                Testear Envío
              </button>
            </div>
          </form>
        </ng-template>
      </mat-expansion-panel>

      <!-- Parametros Comprobantes -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon color="primary">article</mat-icon>
            Comprobantes
          </mat-panel-title>
          <mat-panel-description>
            Notas y textos en documentos
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="small" color="#009688" type="line-scale"
            [fullScreen]="false">
          </ngx-spinner>
          <form [formGroup]="formComprobantes">
            <mat-tab-group>
              <mat-tab label="Nota Resumen">
                <div class="editor-container">
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.NotaResumen || 'Texto que aparece en los documentos de resumen'}}
                  </p>
                  <div class="NgxEditor__Wrapper">
                    <ngx-editor-menu [editor]="editorResumen" [toolbar]="toolbar"></ngx-editor-menu>
                    <ngx-editor [editor]="editorResumen" formControlName="NotaResumen" [disabled]="false"
                      [placeholder]="'Escriba aquí...'">
                    </ngx-editor>
                  </div>
                </div>
              </mat-tab>

              <mat-tab label="Nota Recibo">
                <div class="editor-container">
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.NotaRecibo || 'Texto que aparece en los recibos'}}
                  </p>
                  <div class="NgxEditor__Wrapper">
                    <ngx-editor-menu [editor]="editorRecibo" [toolbar]="toolbar"></ngx-editor-menu>
                    <ngx-editor [editor]="editorRecibo" formControlName="NotaRecibo" [disabled]="false"
                      [placeholder]="'Escriba aquí...'">
                    </ngx-editor>
                  </div>
                </div>
              </mat-tab>

              <mat-tab label="Nota Liquidación">
                <div class="editor-container">
                  <p class="parametro-descripcion">
                    {{parametroSistemaDescripcion.NotaLiquidacion || 'Texto que aparece en las liquidaciones'}}
                  </p>
                  <div class="NgxEditor__Wrapper">
                    <ngx-editor-menu [editor]="editorLiquidacion" [toolbar]="toolbar"></ngx-editor-menu>
                    <ngx-editor [editor]="editorLiquidacion" formControlName="NotaLiquidacion" [disabled]="false"
                      [placeholder]="'Escriba aquí...'">
                    </ngx-editor>
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>

            <div class="actions-container">
              <button mat-raised-button color="primary" (click)="onSubmitParametrosComprobantes()"
                [disabled]="!formComprobantes.valid" *appRole="['Configuracion.Ver']">
                <mat-icon>save</mat-icon>
                Guardar Cambios
              </button>
            </div>
          </form>
        </ng-template>
      </mat-expansion-panel>

    </mat-accordion>
  </div>
</div>
